export const toPascalCase = (input: string): string | undefined => {
  if (!input) {
    return;
  }
  return input.replace(/(^\w|-\w| \w)/g, (m) => m.replace(/-|\s/, '').toUpperCase());
};
